import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AccordionTableComponent } from './accordion-table/accordion-table.component';
import {
  BasicDialogComponent,
  OptionDialogComponent,
  ChangePasswordDialogComponent,
  ConfirmReceiptDialogComponent,
  DeliveryCodeDialogComponent,
  PreviewPhotoDialogComponent,
  CommentDashboardDialogComponent,
  SuccessDialogComponent,
  OrderFiltersDrawerComponent,
  OnboardingTourDialogComponent,
  DownloadOrdersDialogComponent,
} from './dialogs';
import { ReceiptDropzoneComponent } from './receipt-dropzone/receipt-dropzone.component';
import { MenuTooltipComponent } from './menu-tooltip/menu-tooltip.component';
import { AngularMaterialModule } from '@angular-material';
import { provideNativeDateAdapter } from '@angular/material/core';
import { InfoTooltipComponent } from './info-tooltip/info-tooltip.component';
import { ChipSelectComponent } from './chip-select/chip-select.component';
import { PasswordFormComponent } from './templates/password-form/password-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { OrderDetailCardComponent } from './order-detail-card/order-detail-card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NanaykunaUiKitModule } from '@nanaykuna-ui-kit';
import { DirectivesModule } from '@directives';
import { WelcomeCardComponent } from './welcome-card/welcome-card.component';
import { OrderDriverCardComponent } from './order-driver-card/order-driver-card.component';
import { PipesModule } from '@pipes';
import { AlertComponent } from './alert/alert.component';
import { NotificationBannerComponent } from './notification-banner/notification-banner.component';
import { PinFieldComponent } from './pin-field/pin-field.component';
import { ProductAccordionComponent } from './product-accordion/product-accordion.component';
import { CameraButtonComponent } from './camera-button/camera-button.component';
import { FilterMultiSelectComponent } from './filter-multi-select/filter-multi-select.component';
import { FilterButtonComponent } from './filter-button/filter-button.component';
import { DueSoonBannerComponent } from './due-soon-banner/due-soon-banner.component';
import { DIGICEM_DATE_FORMATS } from '@utils';
import { AccessHeaderComponent } from './access-layout/access-header.component';
import { AccessActionsComponent } from './access-layout/access-actions.component';

@NgModule({
  declarations: [
    AccordionTableComponent,
    BasicDialogComponent,
    MenuTooltipComponent,
    OptionDialogComponent,
    InfoTooltipComponent,
    ChipSelectComponent,
    PasswordFormComponent,
    ChangePasswordDialogComponent,
    OrderDetailCardComponent,
    ReceiptDropzoneComponent,
    ConfirmReceiptDialogComponent,
    WelcomeCardComponent,
    OrderDriverCardComponent,
    AlertComponent,
    NotificationBannerComponent,
    DeliveryCodeDialogComponent,
    PinFieldComponent,
    ProductAccordionComponent,
    CameraButtonComponent,
    PreviewPhotoDialogComponent,
    CommentDashboardDialogComponent,
    SuccessDialogComponent,
    OrderFiltersDrawerComponent,
    FilterMultiSelectComponent,
    FilterButtonComponent,
    DueSoonBannerComponent,
    OnboardingTourDialogComponent,
    DownloadOrdersDialogComponent,
    AccessHeaderComponent,
    AccessActionsComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    NanaykunaUiKitModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    MatDialogModule,
    NgxSkeletonLoaderModule.forRoot({
      theme: {
        margin: '0px',
        padding: '0px',
      },
      animation: 'progress',
    }),
    PipesModule,
  ],
  exports: [
    AccordionTableComponent,
    BasicDialogComponent,
    MenuTooltipComponent,
    OptionDialogComponent,
    InfoTooltipComponent,
    ChipSelectComponent,
    PasswordFormComponent,
    ChangePasswordDialogComponent,
    OrderDetailCardComponent,
    ReceiptDropzoneComponent,
    ConfirmReceiptDialogComponent,
    WelcomeCardComponent,
    OrderDriverCardComponent,
    AlertComponent,
    NotificationBannerComponent,
    DeliveryCodeDialogComponent,
    PinFieldComponent,
    CameraButtonComponent,
    PreviewPhotoDialogComponent,
    CommentDashboardDialogComponent,
    SuccessDialogComponent,
    OrderFiltersDrawerComponent,
    FilterMultiSelectComponent,
    FilterButtonComponent,
    DueSoonBannerComponent,
    OnboardingTourDialogComponent,
    DownloadOrdersDialogComponent,
    AccessHeaderComponent,
    AccessActionsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [provideNativeDateAdapter(DIGICEM_DATE_FORMATS), DatePipe],
})
export class ComponentsModule {}
